import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectiuniService } from '../sectiuni.service';
import { ISectiune, ISectiuneUpdatePayload } from '../sectiuni.interface';

@Component({
  selector: 'app-edit-sectiune',
  templateUrl: './edit-sectiune.component.html',
  styleUrls: ['./edit-sectiune.component.scss'],
})
export class EditSectiuneComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name, [Validators.required]),
    slug: new FormControl(this.data.slug, [Validators.required]),
    observations: new FormControl(this.data.observations, []),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ISectiune,
    private dialogRef: MatDialogRef<EditSectiuneComponent>,
    private sectiuniService: SectiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.sectiuniService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatedSectiuneData: ISectiuneUpdatePayload = {
      id: this.data.id,
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observations')?.value,
    };

    this.sectiuniService
      .updateSection(updatedSectiuneData)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(
          this.errorTitle,
          msg,
          this.errorIcon
        );
      });
    } else {
      let errorMessage =
        environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(
        this.errorTitle,
        errorMessage,
        this.errorIcon
      );
    }
  }
}
